import * as React from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

interface BasicDatePickerProps {
  label?: string;
  name?: string;
  value: any;
  onChange: (date: any) => void;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  sx?: any;
  margin?: 'none' | 'normal' | 'dense';
}

export default function BasicDatePicker({
  label,
  name,
  value,
  onChange,
  error,
  helperText,
  required,
  sx,
  margin = 'normal'
}: BasicDatePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
        <DatePicker
          label={label}
          value={value}
          onChange={onChange}
          slotProps={{
            textField: {
              error,
              helperText,
              required,
              margin,
              name
            }
          }}
          sx={{
            width: '100%',
            pb: '10px',
            '& .MuiInputBase-root': {
              '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                borderColor: 'error.main',
              }
            },
            '& .MuiFormHelperText-root.Mui-error': {
              color: 'error.main',
              marginLeft: 0,
              marginRight: 0,
            },
            ...sx
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}